import React from 'react';
import Image from 'next/image';
import IMAGES from '../../../public/assets/img';

const LeftPanel = () => {
  return (
    <div className="bg-brand text-white p-8 w-[44%] flex flex-col justify-between relative gap-4 sm:hidden">
      <Image src={IMAGES.login.credlixLogo} width={113} height={34} alt="Credlix Logo"/>
      <div className="mt-xsp">
        <Image src={IMAGES.login.loginBusiness} width={298} height={198} alt="Login Icon" quality={100}/>
        <h2 className="text-[20px] leading-[26px] font-semibold text-[#FECD2F] mt-4">
          Experience a game-changing approach to supply chain financing with Credlix!
        </h2>
        </div>
    </div>
  );
};

export default LeftPanel;
